<template>
  <div v-if="item">
    <v-layout class="px-3 mb-0" row wrap justify-space-between>
      <v-checkbox
        @change="chooseOrder(item, $event)"
        :label="`Order No. ${item.id}`"
        class="col-auto"
        style="width: max-content"
        color="primary"
      ></v-checkbox>
      <!-- <span style="margin-top: 20px">Assignee : -</span> -->
    </v-layout>
    <v-divider></v-divider>
    <v-layout row wrap class="mt-1">
      <v-flex xs7 sm8>
        <div class="pt-2" style="border-right: 1px solid #eee">
          <!-- <v-layout row justify-end class="text-gray"> {{ item.total_points }} </v-layout> -->

          <template v-for="p in item.productdetails">
            <div class="pl-3" :key="`product_${p.id}`">
              <v-layout row wrap>
                <v-flex xs4>
                  <v-img :src="p.photo"></v-img>
                </v-flex>
                <v-flex xs8 class="mt-2 pl-3">
                  <div>{{ p.name }}</div>
                  <template v-if="selectCampaign && selectCampaign.type != 'lucky_draw'">
                    <div class="text-cus">ใช้ {{ p.points / p.quantity }} แต้ม</div>
                    <div class="text-cus">จำนวนที่แลกทั้งหมด {{ p.quantity }} สิทธิ์</div>
                    <div class="text-cus">รวม {{ p.points }} แต้ม</div>
                  </template>
                  <div class="mt-2" v-if="p.ecoupon_status && coupon && coupon.length > 0">
                    <v-divider></v-divider>
                    <div class="mt-2">กรอกข้อมูลคูปอง</div>
                    <div>
                      <template v-if="coupon[coupon.findIndex((f) => f.id == p.id)]">
                        <div
                          v-for="(item, k) in coupon[coupon.findIndex((f) => f.id == p.id)].data"
                          :key="'coupon-' + k"
                        >
                          <div class="z-border-red mt-3 pa-2 mr-2">
                            <span>www.xxxxxx.com/ecoupon?barcode=[</span>
                            <span>
                              <input
                                style="width: 150px"
                                placeholder="กรอกรหัสบาร์โค้ด"
                                :data-vv-as="$t('กรอกรหัสบาร์โค้ด')"
                                v-validate="{
                                  required: true,
                                  barcode_format: true,
                                  dup_barcode: coupon[coupon.findIndex((f) => f.id == p.id)].data
                                }"
                                :name="'barcode-' + p.id + '-' + k"
                                :key="'barcode-' + p.id + '-' + k"
                                :data-vv-scope="'ecoupon-' + p.id"
                                v-model="item.barcode"
                                class="form-control"
                                maxlength="22"
                                type="text"
                                :disabled="item.is_used"
                                :readonly="item.is_used"
                              />
                            </span>
                            <span>]&amount=</span>
                            <span>
                              <input
                                @blur="!item.amount ? (item.amount = 0) : ''"
                                style="width: 150px"
                                placeholder="กรอกมูลค่า E-Coupon เช่น 100"
                                :data-vv-as="$t('กรอกมูลค่า E-Coupon เช่น 100')"
                                v-validate="'required|morethan0'"
                                :name="'amount-' + +p.id + '-' + k"
                                :key="'amount-' + p.id + '-' + k"
                                v-model="item.amount"
                                :data-vv-scope="'ecoupon-' + p.id"
                                class="form-control"
                                maxlength="10"
                                @keypress="keyIsNumber"
                                :disabled="item.is_used"
                                :readonly="item.is_used"
                              />
                            </span>
                            <span>
                              <v-btn
                                tabindex="-1"
                                @click="deleteCoupon(p.id, k)"
                                icon
                                v-if="!item.is_used"
                              >
                                <v-icon color="primary">delete</v-icon></v-btn
                              >
                            </span>
                            <div style="">
                              <div
                                :class="{
                                  'has-error form-control': errors.has(
                                    'ecoupon-' + p.id + '.barcode-' + p.id + '-' + k
                                  ),
                                  'mr-1': true
                                }"
                              >
                                <span
                                  class="text-error"
                                  v-if="
                                    errors.has('ecoupon-' + p.id + '.barcode-' + p.id + '-' + k)
                                  "
                                  >{{
                                    errors.first('ecoupon-' + p.id + '.barcode-' + p.id + '-' + k)
                                  }}</span
                                >
                              </div>
                              <div
                                :class="{
                                  'has-error form-control': errors.has(
                                    'ecoupon-' + p.id + '.amount-' + p.id + '-' + k
                                  )
                                }"
                              >
                                <span
                                  class="text-error"
                                  v-if="errors.has('ecoupon-' + p.id + '.amount-' + p.id + '-' + k)"
                                  >{{
                                    errors.first('ecoupon-' + p.id + '.amount-' + p.id + '-' + k)
                                  }}</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="text-xs-right">
                          <v-btn @click="addmorecoupon(p.id)" flat color="primary"
                            ><em class="mr-2 fas fa-plus" /> เพิ่มคูปอง</v-btn
                          >
                        </div>
                      </template>
                    </div>
                    <v-btn
                      @click="sendEcoupon(p.id)"
                      color="primary"
                      v-if="
                        coupon[coupon.findIndex((f) => f.id == p.id)] &&
                        coupon[coupon.findIndex((f) => f.id == p.id)].isEcouponOpen
                      "
                      >ส่งคูปอง</v-btn
                    >
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <v-divider :key="`divider_product_${p.id}`" />
          </template>
          <div class="pl-3">
            <template v-if="selectCampaign && selectCampaign.type != 'lucky_draw'">
              <div class="mt-2">แต้มทั้งหมด {{ item.original_score || '-' }} แต้ม</div>
              <div class="mt-2">แต้มที่ใช้ทั้งหมด {{ item.total_points }} แต้ม</div>
              <div class="mt-2">
                แต้มคงเหลือ
                {{ item.original_score ? item.original_score - item.total_points : '-' }} แต้ม
              </div>
            </template>

            <v-btn
              outline
              small
              color="primary"
              :disabled="!item.identity_image"
              @click="
                currentIdentity = item.identity_image
                showIdentity = true
              "
            >
              ภาพบัตรประชาชน
            </v-btn>
            <template v-if="item.type == 'lucky_draw'">
              <v-divider></v-divider>
              <v-layout>
                <v-flex class="pa-2">
                  <img
                    src="/static/img/assets/payment/normal_charge_logo.png"
                    alt
                    class="responsive-img"
                    style="max-height: 50px"
                  />
                </v-flex>
                <v-flex class="pa-2 text-xs-right">
                  <div>ไปรษณีย์ไทย EMS</div>
                  <!-- <multiselect
                  v-model="item.shipping_type"
                  :options="shippingOptions"
                  label="name"
                  selectLabel
                  selectedLabel
                  :allow-empty="false"
                  :searchable="false"
                  deselect-label
                  track-by="name"
                  @select="onSelectShipping"
                ></multiselect> -->
                </v-flex>
              </v-layout>
            </template>

            <v-divider></v-divider>
            <div>หมายเหตุ</div>
            <div v-if="item.remarks && !IsEditingRemark">{{ item.remarks }}</div>
            <v-btn icon color="primary" v-if="!IsEditingRemark" @click="IsEditingRemark = true">
              <v-icon>edit</v-icon>
            </v-btn>
            <template v-if="IsEditingRemark">
              <div class="form-control pt-2">
                <textarea
                  type="text"
                  v-model="item.remarks"
                  class="form-control"
                  :placeholder="$t('หมายเหตุ')"
                  maxlength="2000"
                />
              </div>
              <div class="text-xs-center mb-3">
                <v-btn outline color="primary" class="ma-0" small @click="onEditRemark">
                  <em class="far fa-save" />
                  &nbsp;
                  {{ $t('Save') }}
                </v-btn>
              </div></template
            >
            <!-- <div v-if="limitCoupon > 0">
              <v-divider></v-divider>
              <div>กรอกข้อมูลคูปอง</div>
              <div>
                <div v-for="(item, k) in coupon" :key="k">
                  <div>
                    <span>www.xxxxxx.com/ecoupon?barcode=[</span>
                    <span>
                      <input
                        style="width: 150px"
                        placeholder="กรอกรหัสบาร์โค้ด"
                        :data-vv-as="$t('กรอกรหัสบาร์โค้ด')"
                        v-validate="'required|barcode_format'"
                        :name="'barcode' + k"
                        :key="'barcode' + k"
                        data-vv-scope="ecoupon"
                        v-model="item.barcode"
                        class="form-control"
                        type="text"
                      />
                    </span>
                    <span>]&amount=</span>
                    <span>
                      <input
                        @blur="!item.amount ? (item.amount = 0) : ''"
                        style="width: 150px"
                        placeholder="กรอกมูลค่า E-Coupon เช่น 100"
                        :data-vv-as="$t('กรอกมูลค่า E-Coupon เช่น 100')"
                        v-validate="'required|morethan0'"
                        :name="'amount' + k"
                        :key="'amount' + k"
                        v-model="item.amount"
                        data-vv-scope="ecoupon"
                        class="form-control"
                        type="number"
                      />
                    </span>
                    <span>
                      <v-btn tabindex="-1" @click="deleteCoupon(k)" icon v-if="!readonly">
                        <v-icon color="primary">delete</v-icon></v-btn
                      >
                    </span>
                    <div style="display: flex; justify-content: space-between">
                      <div
                        :class="{
                          'has-error form-control': errors.has('barcode' + k),
                          'mr-1': true,
                        }"
                      >
                        <span class="text-error" v-if="errors.has('barcode' + k)">{{
                          errors.first('barcode' + k)
                        }}</span>
                      </div>
                      <div :class="{ 'has-error form-control': errors.has('amount' + k) }">
                        <span class="text-error" v-if="errors.has('amount' + k)">{{
                          errors.first('amount' + k)
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-xs-right">
                  <v-btn @click="addmorecoupon" flat color="primary" v-if="!readonly"
                    ><em class="mr-2 fas fa-plus"/> เพิ่มคูปอง</v-btn
                  >
                </div>
              </div>
              <v-btn
                @click="sendEcoupon"
                color="primary"
                v-if="isEcouponOpen && !item.is_ecoupon_sent"
                >ส่งคูปอง</v-btn
              >
            </div> -->
          </div>
        </div>
      </v-flex>
      <v-flex xs5 sm4>
        <div style="word-break: break-word" class="pa-2">
          <h6 class="mt-2">{{ item.first_name + ' ' + item.last_name }}</h6>
          <div class="mt-2 text-gray" v-if="!IsEditingAddress">
            {{
              (item.address || '') +
              ' ' +
              (item.sub_district || '') +
              ' ' +
              (item.district || '') +
              ' ' +
              (item.province || '') +
              ' ' +
              (item.post_code || '') +
              (item.phone_number ? ' , เบอร์โทรศัพท์ ' + item.phone_number : '')
            }}
          </div>
          <div v-else>
            <div>ที่อยู่</div>
            <div class="form-control">
              <textarea
                type="text"
                v-model="item.address"
                class="form-control"
                placeholder="ที่อยู่"
                maxlength="2000"
              />
            </div>
            <div>ตำบล</div>
            <div class="form-control">
              <input v-model="item.sub_district" class="form-control" type="text" name="ตำบล" />
            </div>
            <div>อำเภอ</div>
            <div class="form-control">
              <input v-model="item.district" class="form-control" type="text" name="อำเภอ" />
            </div>
            <div>จังหวัด</div>
            <div class="form-control">
              <input v-model="item.province" class="form-control" type="text" name="จังหวัด" />
            </div>
            <div>รหัสไปรษณีย์</div>
            <div class="form-control">
              <input
                v-model="item.post_code"
                class="form-control"
                type="text"
                name="รหัสไปรษณีย์"
              />
            </div>
            <div>เบอร์โทรศัพท์</div>
            <div class="form-control">
              <input
                v-model="item.phone_number"
                class="form-control"
                type="text"
                name="เบอร์โทรศัพท์"
              />
            </div>
            <div class="text-xs-center text-sm-right mb-3">
              <v-btn outline color="primary" class="ma-0" small @click="IsEditingAddress = false">
                <em class="far fa-share-square" />
                &nbsp; ยกเลิก
              </v-btn>
              <v-btn outline color="primary" class="ma-0" small @click="onUpdateAddress">
                <em class="far fa-save" />
                &nbsp; บันทึก
              </v-btn>
            </div>
          </div>
          <v-btn icon color="primary" v-if="!IsEditingAddress" @click="IsEditingAddress = true">
            <v-icon>edit</v-icon>
          </v-btn>
          <div class="my-4">
            <div>สถานะ</div>
            <div>{{ item.shippoing_status || 'รอดำเนินการ' }}</div>
            <div>ป้ายกำกับ</div>
            <div>-</div>
          </div>
          <v-divider></v-divider>
          <div class="pa-2">
            <!-- selectedShipping -->
            <multiselect
              v-model="item.shipping_status"
              :options="orderStatusOptions"
              :allow-empty="false"
              :searchable="false"
              selectLabel
              selectedLabel
              deselect-label
              @select="onSelectOrderStatus"
            ></multiselect>
          </div>
          <template v-if="item.shipping_status == 'จัดส่งแล้ว'">
            <div class="form-control pt-2">
              <textarea
                type="text"
                v-model="item.tracking_no"
                class="form-control"
                :placeholder="$t('Tracking')"
                maxlength="2000"
              />
            </div>
            <div class="text-xs-center text-sm-right mb-3">
              <v-btn outline color="primary" class="ma-0" small @click="onUpdateTrackingNo">
                <em class="far fa-save" />
                &nbsp;
                {{ $t('Save') }}
              </v-btn>
              <v-btn
                outline
                color="primary"
                class="ma-0"
                small
                @click="onSendTrackingNo"
                :disabled="!IsSaveTrackingNo"
              >
                <em class="far fa-share-square" />
                &nbsp;
                {{ $t('Send') }}
              </v-btn>
            </div>
          </template>
        </div>
      </v-flex>
    </v-layout>
    <v-dialog v-model="showIdentity" scrollable max-width="500px">
      <v-card>
        <div class="text-xs-right">
          <v-btn
            small
            flat
            fab
            @click="
              currentIdentity = null
              showIdentity = false
            "
          >
            <v-icon> close </v-icon>
          </v-btn>
        </div>
        <v-card-text v-if="currentIdentity">
          <img style="width: 100%" :src="currentIdentity" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import api from '@/api'
import { mapGetters } from 'vuex'
import { Validator } from 'vee-validate'
Validator.extend('barcode_format', {
  validate: (value) => {
    let result = value.length == 22
    return result
  },
  getMessage: (field) => 'บาร์โค้ดต้องครบ 22 หลัก'
})

Validator.extend('dup_barcode', {
  validate: (value, options) => {
    let barcodes = options.filter((el) => {
      return el.barcode == value
    })
    if (barcodes.length > 1) return false
    return true
  },
  getMessage: (field) => 'หมายเลขคูปองซ้ำ'
})
export default {
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  components: {
    Multiselect
  },
  data() {
    return {
      IsEditingRemark: false,
      selectedShipping: null,
      coupon: [],
      limitCoupon: 0,
      isEcouponOpen: true,
      readonly: false,
      orderStatusOptions: ['รอจัดส่ง', 'จัดส่งแล้ว', 'ยกเลิก'],
      IsSaveTrackingNo: false,
      IsEditingAddress: false,
      item: null,
      currentIdentity: null,
      showIdentity: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    selectCampaign() {
      return this.$store.state.selectToaCampaign
    }
  },
  mounted() {
    this.item = this.value

    let productEcoupon = this.item.productdetails.filter(
      (f) => f.hasOwnProperty('ecoupon_status') && f.ecoupon_status
    )
    if (productEcoupon && productEcoupon.length > 0) {
      productEcoupon.forEach((p) => {
        let coupon = this.item.ecoupon ? this.item.ecoupon.find((el) => el.id == p.id) : null

        if (!coupon) this.addmorecoupon(p.id)
        else {
          // this.readonly = true
          coupon.data.forEach((el) => (el.is_used = true))
          coupon.isEcouponOpen = false
          this.coupon.push(coupon)
        }
      })
    }
  },
  methods: {
    onSelectOrderStatus(status) {
      this.item.shipping_status = status
      this.$store.dispatch('loading')
      let payload = {
        pageid: this.selectedBot.pageid,
        rewardIds: [this.item.id],
        shipping_status: status
      }
      api.TOAECOUPONUpdateShippingRewardStatus(payload, (err, result) => {
        this.$store.dispatch('loading')
      })

      this.$emit('input', this.item)
    },
    async onSendTrackingNo() {
      await this.$swal
        .fire({
          icon: 'question',
          text: 'คุณต้องการส่งเลข Tracking ใช่หรือไม่',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        })
        .then((result) => {
          if (result.value) {
            this.$store.dispatch('loading')
            let payload = {
              pageid: this.selectedBot.pageid,
              rewardId: this.item.id
            }
            api.TOAECOUPONSendingTrackingForReward(payload, (err, result) => {
              this.$store.dispatch('loading')
            })

            this.$emit('input', this.item)
          }
        })
    },
    onSelectShipping(val) {
      let data = {
        pageid: this.selectedBot.pageid,
        rewardId: this.item.id,
        shipping_type: val.name
      }
      this.updateData(data)
    },
    onEditRemark() {
      let data = {
        pageid: this.selectedBot.pageid,
        rewardId: this.item.id,
        remarks: this.item.remarks
      }
      this.updateData(data)
      this.IsEditingRemark = false
    },
    onUpdateTrackingNo() {
      let data = {
        pageid: this.selectedBot.pageid,
        rewardId: this.item.id,
        tracking_no: this.item.tracking_no,
        shipping_type: 'ไปรษณีย์ไทย EMS'
      }
      this.updateData(data)
    },
    updateData(data) {
      this.$store.dispatch('loading')
      api.TOAECOUPONUpdateShippingReward(data, (err, result) => {
        this.$store.dispatch('loading')
        if (result.responsecode == 200) {
          this.IsSaveTrackingNo = true
        }
      })
      this.$emit('input', this.item)
    },
    addmorecoupon(productId) {
      if (this.coupon && this.coupon.length > 0) {
        let index = this.coupon.findIndex((f) => f.id == productId)
        if (index != -1) {
          this.coupon[index].data.push({
            barcode: '',
            amount: '',
            is_used: false
          })
          this.coupon[index].isEcouponOpen = true
        } else {
          this.coupon.push({
            id: productId,
            data: [{ barcode: '', amount: '', is_used: false }],
            isEcouponOpen: true
          })
        }
      } else {
        this.coupon.push({
          id: productId,
          data: [{ barcode: '', amount: '', is_used: false }],
          isEcouponOpen: true
        })
      }
      this.$set(this.item, 'is_ecoupon_sent', false)
    },
    deleteCoupon(productId, index) {
      let pIndex = this.coupon.findIndex((f) => f.id == productId)
      this.coupon[pIndex].data.splice(index, 1)
      let has_available = this.coupon[pIndex].data.some((el) => !el.is_used)
      this.coupon[pIndex].isEcouponOpen = has_available
    },
    async sendEcoupon(productId) {
      let IsValidate = await this.$validator.validateAll('ecoupon-' + productId)
      if (IsValidate) {
        await this.$swal
          .fire({
            icon: 'question',
            text: 'คุณต้องการส่ง E-COUPON ใช่หรือไม่',
            showCancelButton: true,
            cancelButtonText: 'ยกเลิก',
            confirmButtonText: 'ตกลง'
          })
          .then((result) => {
            if (result.value) {
              this.$store.dispatch('loading')
              let data = {
                pageid: this.selectedBot.pageid,
                ecoupon: this.coupon.find((f) => f.id == productId).data,
                productId: productId,
                orderId: this.item.id,
                userId: this.item.userid
              }
              api.TOAECOUPONSendEcouponByRewardOrder(data, (err, result) => {
                this.$store.dispatch('loading')
                if (err) return false
                let coupon = this.coupon.find((f) => f.id == productId)
                this.$set(coupon, 'isEcouponOpen', false)
                coupon.isEcouponOpen = false
                coupon.data.forEach((el) => (el.is_used = true))
                // this.$set(coupon,is_used)
                this.$set(this.coupon, 'isEcouponOpen', false)
                // After send successfully, then disable send ecoupon button
                this.IsEcouponOpen = false
                // if (this.coupon)
                //   this.coupon.forEach(coupon => coupon.data.forEach(el => (el.is_used = true)))
                this.$set(this.item, 'is_ecoupon_sent', true)
              })
              // After send successfully, then disable send ecoupon button
            }
          })
      }
    },
    onUpdateAddress() {
      this.$store.dispatch('loading')
      let payload = {
        pageid: this.selectedBot.pageid,
        id: this.item.id,
        address: this.item.address,
        sub_district: this.item.sub_district,
        district: this.item.district,
        province: this.item.province,
        post_code: this.item.post_code,
        phone_number: this.item.phone_number
      }

      api.TOAECOUPONUpdateAddressByRewardOrder(payload, (err, result) => {
        this.$store.dispatch('loading')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/SendingReward/RewardItem.vue